import { Tag } from './tag';

export interface TreatmentTag extends Tag {
    treatmentId: number;
    count?: number;
}
